import Vue from 'vue';

import { formatDate, formatDateTime, isValidDate } from '@/services/dateFormatter';
import { formatMontant } from '@/services/NumberFormater';

import { getStatutLabel } from '@/services/constantes';

Vue.filter('formatDate', formatDate);
Vue.filter('formatDateTime', formatDateTime);
Vue.filter('isValidDate', isValidDate);
Vue.filter('getStatutLabel', getStatutLabel);
Vue.filter('formatMontant', formatMontant);
